import type { LocalizedText } from "@/math";

export type HeroAvatar = "boy" | "girl";

export interface HeroAvatarDef {
  id: HeroAvatar;
  name: LocalizedText;
  /** Sprite sheet key (16×16 frames, rows = down/up/left/right). */
  texture: string;
  file: string;
  faceset: string;
}

export const HERO_AVATARS: Record<HeroAvatar, HeroAvatarDef> = {
  boy: {
    id: "boy",
    name: { pl: "Chłopiec", en: "Boy" },
    texture: "hero-boy",
    file: "characters/Boy.png",
    faceset: "assets/ninja/facesets/Boy.png",
  },
  girl: {
    id: "girl",
    name: { pl: "Dziewczynka", en: "Girl" },
    texture: "hero-girl",
    file: "characters/Princess.png",
    faceset: "assets/ninja/facesets/Princess.png",
  },
};

export function avatarDef(id: string | undefined): HeroAvatarDef {
  return HERO_AVATARS[(id as HeroAvatar) ?? "boy"] ?? HERO_AVATARS.boy;
}
